<template>
  <q-btn
    icon="fas fa-file-export"
    title="Export to Report"
    round
    flat
    @click="openModal"
  />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import openModal from '@/components/modal';
import ExportToReportModal from './ExportToReportModal.vue';

export default defineComponent({
  props: {
    postSearchId: {
      type: Number,
      required: true,
    },
  },
  methods: {
    openModal() {
      const config = {
        parent: this,
        postSearchId: this.postSearchId,
      };
      openModal(ExportToReportModal, config);
    },
  },
});
</script>
